import { useState, useEffect } from "react";
import { saveEmployee, getReport, getOnline, allowExtraShift, setAllowExtraDB, getShoppingList, markShoppingDone, deleteShoppingItem } from "../api";
import jsPDF from "jspdf";



function getToday() { return new Date().toLocaleDateString("de-DE"); }
function getTime() { return new Date().toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" }); }
const COLORS = ["#00E5FF","#22C55E","#F59E0B","#EF4444","#A855F7","#EC4899"];

export default function AdminScreen({ employees, setEmployees, attendance, allowExtra, setAllowExtra, activeTab, setActiveTab, onLogout }) {
  const today = getToday();
  const [filter, setFilter] = useState("today");
  const [reportSales, setReportSales] = useState([]);
  const [reportAttendance, setReportAttendance] = useState([]);
  const [reportMeldungen, setReportMeldungen] = useState([]);
  const [onlineNow, setOnlineNow] = useState([]);
  const [loadingReport, setLoadingReport] = useState(true);
  const [shoppingList, setShoppingList] = useState([]);
  const [allowExtraList, setAllowExtraList] = useState([]);
  const [currentTime, setCurrentTime] = useState(getTime());
  const [newName, setNewName] = useState("");
  const [newPin, setNewPin] = useState("");
  const [newColor, setNewColor] = useState(COLORS[0]);
  const [adding, setAdding] = useState(false);
  const [showPdfMenu, setShowPdfMenu] = useState(false);
  const [meldungenRead, setMeldungenRead] = useState(() => {
    try { return localStorage.getItem("xbent_meldungen_read") === String(new Date().toLocaleDateString("de-DE")); } catch(e) { return false; }
  });

  useEffect(() => {
    const t = setInterval(() => setCurrentTime(getTime()), 1000);
    return () => clearInterval(t);
  }, []);

  function loadReport() {
    getOnline().then(r => setOnlineNow(r.online || [])).catch(()=>{});
    getShoppingList().then(data => { setShoppingList(Array.isArray(data) ? data : []); }).catch(()=>{});
    import("../api").then(({supabase: sb}) => {}).catch(()=>{});
    fetch("https://bywsyoscrcpuyunqyqpe.supabase.co/rest/v1/allow_extra?select=*&date=eq." + today, { headers: { "apikey": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ5d3N5b3NjcmNwdXl1bnF5cXBlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODAzOTk3NzgsImV4cCI6MjA5NTk3NTc3OH0.JA0FGJZW6wNpiPEtLo3FqXhrs0tVHBXijDhMPjLKBYc", "Authorization": "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ5d3N5b3NjcmNwdXl1bnF5cXBlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODAzOTk3NzgsImV4cCI6MjA5NTk3NTc3OH0.JA0FGJZW6wNpiPEtLo3FqXhrs0tVHBXijDhMPjLKBYc" } }).then(r=>r.json()).then(data=>setAllowExtraList(data.map(d=>d.employee_name))).catch(()=>{});
    
    getReport()
      .then(data => {
        setReportSales(data.sales || []);
        setReportAttendance(data.attendance || []);
        setReportMeldungen(data.meldungen || []);
        
        setLoadingReport(false);
      })
      .catch(() => setLoadingReport(false));
  }

  useEffect(() => {
    loadReport();
    const interval = setInterval(loadReport, 10000);
    return () => clearInterval(interval);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function normalizeDate(d) {
    return String(d).split(".").map((p,i) => i<2 ? p.replace(/^0+/,"") : p).join(".");
  }

  function parseDate(dateStr) {
    if (!dateStr) return new Date(0);
    const parts = String(dateStr).split(".");
    if (parts.length === 3) return new Date(parts[2], parts[1]-1, parts[0]);
    return new Date(dateStr);
  }

  function getFilteredSales() {
    const now = new Date();
    return reportSales.filter(s => {
      const d = parseDate(s.date);
      if (filter === "today") return normalizeDate(s.date) === today;
      if (filter === "week") { const w = new Date(now); w.setDate(now.getDate()-7); return d >= w; }
      if (filter === "month") return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
      return true;
    });
  }

  function getFilteredAttendance() {
    const now = new Date();
    return reportAttendance.filter(a => {
      const d = parseDate(a.date);
      if (filter === "today") return normalizeDate(a.date) === today;
      if (filter === "week") { const w = new Date(now); w.setDate(now.getDate()-7); return d >= w; }
      if (filter === "month") return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
      return true;
    });
  }

  const filteredSales = getFilteredSales();
  const filteredAtt = getFilteredAttendance();
  const totalRevenue = filteredSales.reduce((sum,s) => sum+Number(s.price), 0);
  const barRevenue = filteredSales.filter(s => s.payment==="Bar").reduce((sum,s) => sum+Number(s.price), 0);
  const karteRevenue = filteredSales.filter(s => s.payment==="Karte").reduce((sum,s) => sum+Number(s.price), 0);
  const newMeldungen = meldungenRead ? 0 : reportMeldungen.filter(m => normalizeDate(m.date) === today).length;

  // Best employee
  const empSalesMap = {};
  filteredSales.forEach(s => { empSalesMap[s.employeeName] = (empSalesMap[s.employeeName]||0) + Number(s.price); });
  const bestEmp = Object.keys(empSalesMap).sort((a,b) => empSalesMap[b]-empSalesMap[a])[0];

  function generatePDF(type) {
    setShowPdfMenu(false);
    const doc = new jsPDF();
    const periodLabel = { today:"Heute", week:"Woche", month:"Monat", all:"Alle" }[filter];
    const now = new Date();

    // ========== COVER PAGE ==========
    doc.setFillColor(10, 10, 10);
    doc.rect(0, 0, 210, 297, "F");
    doc.setFillColor(0, 229, 255);
    doc.rect(0, 0, 210, 60, "F");
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(36);
    doc.setFont("helvetica", "bold");
    doc.text("XBENT", 14, 35);
    doc.setFontSize(14);
    doc.setFont("helvetica", "normal");
    doc.text("Kassensystem Report", 14, 50);
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(13);
    doc.text("Zeitraum: " + periodLabel, 14, 85);
    doc.text("Erstellt: " + today + " " + getTime(), 14, 97);
    doc.text("Mitarbeiter: " + employees.length, 14, 109);

    // Summary boxes
    const boxes = [
      { label: "Gesamt", value: "EUR " + totalRevenue.toFixed(2), color: [0, 229, 255] },
      { label: "Bar", value: "EUR " + barRevenue.toFixed(2), color: [34, 197, 94] },
      { label: "Karte", value: "EUR " + karteRevenue.toFixed(2), color: [168, 85, 247] },
      { label: "Verkaufe", value: filteredSales.length + " Stk", color: [245, 158, 11] },
    ];
    boxes.forEach((b, i) => {
      const x = 14 + (i % 2) * 92;
      const y = 130 + Math.floor(i / 2) * 40;
      doc.setFillColor(20, 20, 20);
      doc.rect(x, y, 85, 32, "F");
      doc.setDrawColor(...b.color);
      doc.rect(x, y, 85, 32);
      doc.setTextColor(...b.color);
      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");
      doc.text(b.value, x + 6, y + 14);
      doc.setTextColor(150, 150, 150);
      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");
      doc.text(b.label, x + 6, y + 24);
    });

    // Best employee
    const empSalesMap = {};
    filteredSales.forEach(s => { empSalesMap[s.employeeName] = (empSalesMap[s.employeeName] || 0) + Number(s.price); });
    const bestEmpName = Object.keys(empSalesMap).sort((a, b) => empSalesMap[b] - empSalesMap[a])[0];
    if (bestEmpName) {
      doc.setFillColor(245, 158, 11, 0.2);
      doc.setFillColor(30, 20, 0);
      doc.rect(14, 218, 182, 20, "F");
      doc.setTextColor(245, 158, 11);
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text("Bester Mitarbeiter: " + bestEmpName + " — EUR " + (empSalesMap[bestEmpName] || 0).toFixed(2), 20, 230);
    }

    doc.setTextColor(80, 80, 80);
    doc.setFontSize(8);
    doc.text("XBENT Kassensystem | " + today, 14, 285);

    // ========== PAGE 2: SALES TABLE ==========
    if (type === "full" || type === "sales") {
      doc.addPage();
      doc.setFillColor(0, 229, 255);
      doc.rect(0, 0, 210, 18, "F");
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text("VERKAUFE — " + periodLabel.toUpperCase(), 14, 12);

      let y = 28;
      // Table header
      doc.setFillColor(20, 20, 20);
      doc.rect(14, y, 182, 8, "F");
      doc.setTextColor(0, 229, 255);
      doc.setFontSize(8);
      ["Datum", "Zeit", "Mitarbeiter", "Kategorie", "Beschreibung", "Preis", "Zahlung"].forEach((h, i) => {
        const xs = [16, 36, 56, 88, 118, 162, 182];
        doc.text(h, xs[i], y + 6);
      });
      y += 10;

      [...filteredSales].reverse().forEach((sale, i) => {
        if (y > 275) {
          doc.addPage();
          y = 20;
        }
        if (i % 2 === 0) { doc.setFillColor(248, 248, 248); doc.rect(14, y - 4, 182, 8, "F"); }
        doc.setTextColor(0, 0, 0);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(7.5);
        doc.text(String(sale.date || ""), 16, y);
        doc.text(String(sale.time || "").substring(0, 5), 36, y);
        doc.text(String(sale.employeeName || "").substring(0, 10), 56, y);
        doc.text(String(sale.category || ""), 88, y);
        doc.text(String(sale.description || "").substring(0, 15), 118, y);
        doc.setFont("helvetica", "bold");
        doc.text("EUR " + Number(sale.price || 0).toFixed(2), 155, y);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(sale.payment === "Bar" ? 34 : 168, sale.payment === "Bar" ? 197 : 85, sale.payment === "Bar" ? 94 : 247);
        doc.text(String(sale.payment || ""), 182, y);
        doc.setTextColor(0, 0, 0);
        y += 8;
      });

      // Sales totals
      y += 5;
      doc.setFillColor(0, 229, 255);
      doc.rect(14, y, 182, 10, "F");
      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.text("GESAMT: EUR " + totalRevenue.toFixed(2) + "   BAR: EUR " + barRevenue.toFixed(2) + "   KARTE: EUR " + karteRevenue.toFixed(2), 16, y + 7);
    }

    // ========== PAGE: EMPLOYEE REPORTS ==========
    if (type === "full" || type === "employees") {
      employees.forEach(emp => {
        doc.addPage();
        // Employee header
        doc.setFillColor(20, 20, 20);
        doc.rect(0, 0, 210, 297, "F");
        doc.setFillColor(0, 229, 255);
        doc.rect(0, 0, 210, 25, "F");
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(16);
        doc.setFont("helvetica", "bold");
        doc.text(emp.name.toUpperCase(), 14, 17);
        doc.setFontSize(9);
        doc.text("Mitarbeiter Report — " + periodLabel, 120, 17);

        const empSales = filteredSales.filter(s => s.employeeName === emp.name);
        const empTotal = empSales.reduce((s, a) => s + Number(a.price), 0);
        const empBar = empSales.filter(s => s.payment === "Bar").reduce((s, a) => s + Number(a.price), 0);
        const empKarte = empSales.filter(s => s.payment === "Karte").reduce((s, a) => s + Number(a.price), 0);
        const empAtt = filteredAtt.filter(a => a.employeeName === emp.name);
        const empHours = empAtt.reduce((s, a) => s + Number(a.hours || 0), 0);
        const empDays = new Set(empAtt.map(a => a.date)).size;
        const avgSale = empSales.length > 0 ? empTotal / empSales.length : 0;

        // Stats grid
        const stats = [
          { label: "Gesamt Umsatz", value: "EUR " + empTotal.toFixed(2), color: [0, 229, 255] },
          { label: "Bar", value: "EUR " + empBar.toFixed(2), color: [34, 197, 94] },
          { label: "Karte", value: "EUR " + empKarte.toFixed(2), color: [168, 85, 247] },
          { label: "Stunden", value: empHours.toFixed(1) + "h", color: [245, 158, 11] },
          { label: "Arbeitstage", value: empDays + " Tage", color: [239, 68, 68] },
          { label: "Ø pro Verkauf", value: "EUR " + avgSale.toFixed(2), color: [100, 200, 255] },
        ];
        stats.forEach((s, i) => {
          const x = 14 + (i % 3) * 63;
          const y2 = 35 + Math.floor(i / 3) * 35;
          doc.setFillColor(30, 30, 30);
          doc.rect(x, y2, 58, 28, "F");
          doc.setTextColor(...s.color);
          doc.setFontSize(13);
          doc.setFont("helvetica", "bold");
          doc.text(s.value, x + 4, y2 + 13);
          doc.setTextColor(120, 120, 120);
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");
          doc.text(s.label, x + 4, y2 + 22);
        });

        // Category breakdown
        let y3 = 115;
        doc.setTextColor(0, 229, 255);
        doc.setFontSize(9);
        doc.setFont("helvetica", "bold");
        doc.text("VERKAUFE NACH KATEGORIE", 14, y3);
        y3 += 6;
        const cats = ["Huelle", "Glass", "Zubehoer", "Spielzeug"];
        cats.forEach(cat => {
          const catSales = empSales.filter(s => s.category === cat);
          if (catSales.length === 0) return;
          const catTotal = catSales.reduce((s, a) => s + Number(a.price), 0);
          doc.setFillColor(25, 25, 25);
          doc.rect(14, y3, 182, 8, "F");
          doc.setTextColor(255, 255, 255);
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");
          doc.text(cat, 16, y3 + 6);
          doc.text(catSales.length + " Stk", 80, y3 + 6);
          doc.setFont("helvetica", "bold");
          doc.text("EUR " + catTotal.toFixed(2), 150, y3 + 6);
          y3 += 10;
        });

        // Attendance
        y3 += 5;
        doc.setTextColor(0, 229, 255);
        doc.setFontSize(9);
        doc.setFont("helvetica", "bold");
        doc.text("ANWESENHEIT", 14, y3);
        y3 += 6;
        doc.setFillColor(20, 20, 20);
        doc.rect(14, y3, 182, 8, "F");
        doc.setTextColor(0, 229, 255);
        doc.setFontSize(7.5);
        ["Datum", "Von", "Bis", "Stunden"].forEach((h, i) => {
          doc.text(h, [16, 60, 100, 150][i], y3 + 6);
        });
        y3 += 10;
        empAtt.forEach((a, i) => {
          if (y3 > 270) return;
          if (i % 2 === 0) { doc.setFillColor(30, 30, 30); doc.rect(14, y3 - 4, 182, 8, "F"); }
          doc.setTextColor(200, 200, 200);
          doc.setFont("helvetica", "normal");
          doc.text(String(a.date || ""), 16, y3);
          doc.text(String(a.startTime || ""), 60, y3);
          doc.text(String(a.endTime || "-"), 100, y3);
          doc.setTextColor(245, 158, 11);
          doc.setFont("helvetica", "bold");
          doc.text(Number(a.hours || 0).toFixed(1) + "h", 150, y3);
          y3 += 8;
        });

        // Footer
        doc.setTextColor(60, 60, 60);
        doc.setFontSize(7);
        doc.setFont("helvetica", "normal");
        doc.text("XBENT Kassensystem | " + today, 14, 285);
      });
    }

    // ========== PAGE: ATTENDANCE SUMMARY ==========
    if (type === "full" || type === "attendance") {
      doc.addPage();
      doc.setFillColor(0, 229, 255);
      doc.rect(0, 0, 210, 18, "F");
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text("ANWESENHEIT — " + periodLabel.toUpperCase(), 14, 12);

      let ya = 28;
      doc.setFillColor(20, 20, 20);
      doc.rect(14, ya, 182, 8, "F");
      doc.setTextColor(0, 229, 255);
      doc.setFontSize(8);
      ["Datum", "Mitarbeiter", "Von", "Bis", "Stunden"].forEach((h, i) => {
        doc.text(h, [16, 50, 95, 130, 165][i], ya + 6);
      });
      ya += 10;

      [...filteredAtt].reverse().forEach((a, i) => {
        if (ya > 275) { doc.addPage(); ya = 20; }
        if (i % 2 === 0) { doc.setFillColor(248, 248, 248); doc.rect(14, ya - 4, 182, 8, "F"); }
        doc.setTextColor(0, 0, 0);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(8);
        doc.text(String(a.date || ""), 16, ya);
        doc.text(String(a.employeeName || ""), 50, ya);
        doc.text(String(a.startTime || ""), 95, ya);
        doc.text(String(a.endTime || "-"), 130, ya);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(245, 158, 11);
        doc.text(Number(a.hours || 0).toFixed(1) + "h", 165, ya);
        ya += 8;
      });
    }

    // Page numbers
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(7);
      doc.setTextColor(100, 100, 100);
      doc.text("Seite " + i + " von " + pageCount, 180, 290);
    }

    const filename = "XBENT-" + type + "-" + periodLabel + "-" + today + ".pdf";
    doc.save(filename);
  }


  async function handleAdd() {
    if (!newName || !newPin || newPin.length !== 4) return;
    const emp = { id: Date.now(), name: newName, pin: newPin, color: newColor };
    await saveEmployee({ action: "add", ...emp });
    setEmployees(prev => [...prev, emp]);
    setNewName(""); setNewPin(""); setAdding(false);
  }

  const [confirmDelete, setConfirmDelete] = useState(null);

  async function handleDelete(emp) {
    if (confirmDelete !== emp.id) { setConfirmDelete(emp.id); setTimeout(() => setConfirmDelete(null), 3000); return; }
    await saveEmployee({ action: "delete", id: emp.id });
    setEmployees(prev => prev.filter(e => e.id !== emp.id));
    setConfirmDelete(null);
  }

  return (
    <div style={{ display:"flex", flexDirection:"column", minHeight:"100vh", backgroundColor:"#0A0A0A" }} className="fade-in">

      {/* Sticky Header */}
      <div style={{ position:"sticky", top:0, zIndex:50, background:"linear-gradient(135deg,#0D0D0D,#111)", borderBottom:"1px solid #1A1A1A", padding:"12px 18px" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
          <div>
            <div style={{ color:"#00E5FF", fontSize:9, letterSpacing:4, marginBottom:2 }}>XBENT ADMIN</div>
            <div style={{ fontSize:20, fontWeight:700 }}>Dashboard</div>
          </div>
          <div style={{ display:"flex", gap:8, alignItems:"center" }}>
            <div style={{ color:"#333", fontSize:10, fontFamily:"Space Mono monospace" }}>{currentTime}</div>
            <button onClick={loadReport} style={{ background:"#00E5FF15", border:"1px solid #00E5FF30", color:"#00E5FF", width:34, height:34, borderRadius:10, cursor:"pointer", fontSize:15, display:"flex", alignItems:"center", justifyContent:"center" }}>↻</button>
            <div style={{ position:"relative" }}>
              <button onClick={() => setShowPdfMenu(p => !p)} style={{ background:"#22C55E15", border:"1px solid #22C55E30", color:"#22C55E", width:34, height:34, borderRadius:10, cursor:"pointer", fontSize:13, display:"flex", alignItems:"center", justifyContent:"center" }}>PDF</button>

              {showPdfMenu && (
                <div style={{ position:"absolute", right:0, top:40, background:"#1A1A1A", border:"1px solid #2A2A2A", borderRadius:12, padding:8, zIndex:100, minWidth:180 }} className="pop-in">
                  {[
                    {key:"full", label:"Vollstaendiger Bericht"},
                    {key:"sales", label:"Nur Verkaufe"},
                    {key:"attendance", label:"Nur Anwesenheit"},
                  ].map(opt => (
                    <button key={opt.key} onClick={() => generatePDF(opt.key)} style={{ display:"block", width:"100%", padding:"10px 14px", background:"transparent", border:"none", color:"#CCC", fontSize:13, cursor:"pointer", textAlign:"left", borderRadius:8 }}
                      onPointerEnter={e => e.currentTarget.style.background="#2A2A2A"}
                      onPointerLeave={e => e.currentTarget.style.background="transparent"}
                    >{opt.label}</button>
                  ))}
                </div>
              )}
            </div>
            <button onClick={onLogout} style={{ background:"#141414", border:"1px solid #222", color:"#555", padding:"8px 12px", borderRadius:10, cursor:"pointer", fontSize:11, fontWeight:600 }}>Exit</button>
          </div>
        </div>
      </div>

      <div style={{ padding:"16px 18px 32px" }}>

        {/* Online Cards */}
        <div style={{ marginBottom:16 }}>
          <div style={{ color:"#333", fontSize:9, letterSpacing:3, marginBottom:10 }}>ONLINE JETZT</div>
          <div style={{ display:"flex", gap:10 }}>
            {employees.map(emp => {
              const isOnline = onlineNow.some(a => a.employeeName.trim() === emp.name.trim());
              const empOnlineData = onlineNow.find(a => a.employeeName.trim() === emp.name.trim());
              const empSalesToday = reportSales.filter(s => s.employeeName === emp.name && normalizeDate(s.date) === today);
              const empTotalToday = empSalesToday.reduce((sum,s) => sum+Number(s.price), 0);
              return (
                <div key={emp.id} style={{ flex:1, background:isOnline?"#111":"#0D0D0D", border:`1px solid ${isOnline?"#00E5FF25":"#1A1A1A"}`, borderRadius:16, padding:"12px 14px" }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:8 }}>
                    <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                      <div style={{ width:36, height:36, borderRadius:10, background:emp.color+"20", border:`1.5px solid ${emp.color}40`, display:"flex", alignItems:"center", justifyContent:"center", color:emp.color, fontWeight:700, fontSize:16 }}>{emp.name[0]}</div>
                      <div>
                        <div style={{ fontWeight:700, fontSize:14 }}>{emp.name}</div>
                        <div style={{ fontSize:10, color:isOnline?"#22C55E":"#444", marginTop:1 }}>{isOnline?"● Online":"Offline"}</div>
                      </div>
                    </div>
                    <div style={{ width:8, height:8, borderRadius:"50%", background:isOnline?"#22C55E":"#333", boxShadow:isOnline?"0 0 6px #22C55E":"none", marginTop:4 }} />
                  </div>
                  {isOnline && empOnlineData && <div style={{ color:"#555", fontSize:10, fontFamily:"Space Mono monospace", marginBottom:6 }}>Von {empOnlineData.startTime}</div>}
                  <div style={{ color:"#00E5FF", fontSize:15, fontWeight:700, fontFamily:"Space Mono monospace" }}>EUR {empTotalToday.toFixed(0)}</div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Best Employee Badge */}
        {bestEmp && (
          <div style={{ background:"linear-gradient(135deg,#F59E0B15,#F59E0B05)", border:"1px solid #F59E0B30", borderRadius:12, padding:"10px 14px", marginBottom:16, display:"flex", alignItems:"center", gap:10 }}>
            <div style={{ fontSize:18 }}>🏆</div>
            <div>
              <div style={{ color:"#F59E0B", fontSize:11, fontWeight:700 }}>Bester Mitarbeiter</div>
              <div style={{ fontSize:13, color:"#CCC" }}>{bestEmp} — EUR {(empSalesMap[bestEmp]||0).toFixed(0)}</div>
            </div>
          </div>
        )}

        {/* Filter */}
        <div style={{ display:"flex", gap:8, marginBottom:14 }}>
          {[{key:"today",label:"Heute"},{key:"week",label:"Woche"},{key:"month",label:"Monat"},{key:"all",label:"Alle"}].map(f => (
            <button key={f.key} onClick={() => setFilter(f.key)} style={{ flex:1, padding:"9px 4px", borderRadius:10, border:`1.5px solid ${filter===f.key?"#00E5FF":"#1E1E1E"}`, background:filter===f.key?"#00E5FF10":"transparent", color:filter===f.key?"#00E5FF":"#444", fontSize:11, fontWeight:700, cursor:"pointer" }}>{f.label}</button>
          ))}
        </div>

        {/* Stats */}
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8, marginBottom:16 }}>
          {[
            {label:"Gesamt",value:totalRevenue,color:"#00E5FF",sub:filteredSales.length+" Verk."},
            {label:"Bar",value:barRevenue,color:"#22C55E",sub:"Bargeld"},
            {label:"Karte",value:karteRevenue,color:"#A855F7",sub:"Karte"}
          ].map(c => (
            <div key={c.label} style={{ background:"#111", border:"1px solid #1A1A1A", borderRadius:14, padding:"12px 8px", textAlign:"center" }}>
              <div style={{ fontFamily:"Space Mono monospace", fontSize:16, fontWeight:700, color:c.color }}>EUR{c.value.toFixed(0)}</div>
              <div style={{ color:"#555", fontSize:9, marginTop:2 }}>{c.label}</div>
              <div style={{ color:"#333", fontSize:8, marginTop:1 }}>{c.sub}</div>
            </div>
          ))}
        </div>

        {/* Tabs */}
        <div style={{ display:"flex", gap:6, marginBottom:16 }}>
          {[{key:"sales",label:"Verkaufe"},{key:"employees",label:"Team"},{key:"attendance",label:"Zeiten"},{key:"meldungen",label:"Meldungen"},{key:"shopping",label:"Einkauf"}].map(t => (
            <button key={t.key} onClick={() => { setActiveTab(t.key); if(t.key==="meldungen"){ setMeldungenRead(true); try{localStorage.setItem("xbent_meldungen_read",today);}catch(e){} } }} style={{ flex:1, padding:"9px 2px", borderRadius:10, border:`1.5px solid ${activeTab===t.key?"#00E5FF":"#1E1E1E"}`, background:activeTab===t.key?"#00E5FF10":"transparent", color:activeTab===t.key?"#00E5FF":"#444", fontSize:10, fontWeight:700, cursor:"pointer", position:"relative" }}>
              {t.label}
              {t.key==="meldungen" && newMeldungen > 0 && <span style={{ position:"absolute", top:-4, right:-4, background:"#EF4444", color:"#FFF", borderRadius:"50%", width:14, height:14, fontSize:9, display:"flex", alignItems:"center", justifyContent:"center" }}>{newMeldungen}</span>}
            </button>
          ))}
        </div>

        {loadingReport && <div style={{ color:"#444", textAlign:"center", padding:"24px 0" }}>Laden...</div>}

        {/* Sales Tab */}
        {!loadingReport && activeTab==="sales" && (
          <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
            {filteredSales.length===0 && <div style={{ color:"#333", textAlign:"center", padding:"48px 0", fontSize:14 }}>Keine Verkaufe</div>}
            {[...filteredSales].reverse().map((sale,i) => (
              <div key={i} style={{ background:"#111", border:"1px solid #1A1A1A", borderRadius:14, padding:"12px 14px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                <div>
                  <div style={{ fontWeight:700, fontSize:15 }}>{sale.category}</div>
                  {sale.description && <div style={{ color:"#555", fontSize:12, marginTop:2 }}>{sale.description}</div>}
                  <div style={{ color:"#383838", fontSize:10, marginTop:3 }}>{sale.employeeName} · {sale.date} · {sale.time}</div>
                </div>
                <div style={{ textAlign:"right" }}>
                  <div style={{ fontFamily:"Space Mono monospace", fontSize:16, fontWeight:700 }}>EUR {Number(sale.price).toFixed(2)}</div>
                  <div style={{ fontSize:10, marginTop:2, color:sale.payment==="Bar"?"#22C55E":"#A855F7" }}>{sale.payment}</div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Team Tab */}
        {!loadingReport && activeTab==="employees" && (
          <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
            {employees.map(emp => {
              const empSales = filteredSales.filter(s => s.employeeName === emp.name);
              const empTotal = empSales.reduce((sum,s) => sum+Number(s.price), 0);
              const empBar = empSales.filter(s => s.payment==="Bar").reduce((sum,s) => sum+Number(s.price), 0);
              const empKarte = empSales.filter(s => s.payment==="Karte").reduce((sum,s) => sum+Number(s.price), 0);
              const empAtt = filteredAtt.filter(a => a.employeeName === emp.name);
              const empHours = empAtt.reduce((sum,a) => sum+Number(a.hours||0), 0);
              const isOnline = onlineNow.some(a => a.employeeName.trim() === emp.name.trim());
              const hadShift = reportAttendance.some(a => (a.employee_name||a.employeeName||"" ).trim() === emp.name.trim() && normalizeDate(String(a.date)) === today && (a.end_time||a.endTime) && (a.end_time||a.endTime) !== "");
              const isAllowed = allowExtra.includes(emp.id) || allowExtraList.includes(emp.name);
              return (
                <div key={emp.id} style={{ background:"#111", border:`1px solid ${isOnline?"#00E5FF20":"#1A1A1A"}`, borderRadius:16, padding:14 }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
                    <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                      <div style={{ position:"relative" }}>
                        <div style={{ width:44, height:44, borderRadius:12, background:emp.color+"18", border:`2px solid ${emp.color}40`, display:"flex", alignItems:"center", justifyContent:"center", color:emp.color, fontWeight:700, fontSize:18 }}>{emp.name[0]}</div>
                        <div style={{ position:"absolute", bottom:-2, right:-2, width:10, height:10, borderRadius:"50%", background:isOnline?"#22C55E":"#444", border:"2px solid #111" }} />
                      </div>
                      <div>
                        <div style={{ fontWeight:700, fontSize:16 }}>{emp.name}</div>
                        <div style={{ color:"#444", fontSize:10, fontFamily:"Space Mono monospace" }}>PIN: {emp.pin}</div>
                      </div>
                    </div>
                    <button onClick={() => handleDelete(emp)} style={{ background:"#EF444410", border:"1px solid #EF444430", color:"#EF4444", padding:"6px 10px", borderRadius:8, cursor:"pointer", fontSize:12 }}>{confirmDelete === emp.id ? "Sicher?" : "×"}</button>
                  </div>
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr 1fr", gap:6, marginBottom: hadShift && !isAllowed ? 10 : 0 }}>
                    {[
                      {label:"Gesamt",value:"EUR "+empTotal.toFixed(0),color:"#00E5FF"},
                      {label:"Bar",value:"EUR "+empBar.toFixed(0),color:"#22C55E"},
                      {label:"Karte",value:"EUR "+empKarte.toFixed(0),color:"#A855F7"},
                      {label:"Stunden",value:empHours.toFixed(1)+"h",color:"#F59E0B"}
                    ].map(s => (
                      <div key={s.label} style={{ background:"#0D0D0D", borderRadius:8, padding:"6px 4px", textAlign:"center" }}>
                        <div style={{ color:s.color, fontWeight:700, fontSize:12, fontFamily:"Space Mono monospace" }}>{s.value}</div>
                        <div style={{ color:"#444", fontSize:8, marginTop:2 }}>{s.label}</div>
                      </div>
                    ))}
                  </div>
                  {hadShift && !isAllowed && (
                    <button onClick={async () => { await setAllowExtraDB(emp.name); await allowExtraShift(emp.name); setAllowExtra(prev => [...prev, emp.id]); }} style={{ width:"100%", padding:"8px", borderRadius:8, border:"1px solid #00E5FF30", background:"#00E5FF10", color:"#00E5FF", fontSize:12, fontWeight:600, cursor:"pointer" }}>
                      Zweite Schicht erlauben
                    </button>
                  )}
                  {isAllowed && <div style={{ textAlign:"center", color:"#22C55E", fontSize:11, padding:"4px 0" }}>✓ Erlaubt</div>}
                </div>
              );
            })}
            {adding ? (
              <div style={{ background:"#111", border:"1px solid #00E5FF30", borderRadius:16, padding:14, display:"flex", flexDirection:"column", gap:10 }} className="pop-in">
                <input type="text" placeholder="Name" value={newName} onChange={e=>setNewName(e.target.value)} />
                <input type="text" placeholder="PIN (4 Ziffern)" maxLength={4} value={newPin} onChange={e=>setNewPin(e.target.value.replace(/\D/,""))} />
                <div style={{ display:"flex", gap:8 }}>
                  {COLORS.map(c => (
                    <div key={c} onClick={() => setNewColor(c)} style={{ width:28, height:28, borderRadius:8, background:c, border:`2px solid ${newColor===c?"#FFF":"transparent"}`, cursor:"pointer" }} />
                  ))}
                </div>
                <div style={{ display:"flex", gap:8 }}>
                  <button onClick={handleAdd} style={{ flex:1, padding:"12px", borderRadius:10, border:"none", background:"linear-gradient(135deg,#00E5FF,#00B8CC)", color:"#000", fontSize:14, fontWeight:700, cursor:"pointer" }}>Hinzufuegen</button>
                  <button onClick={() => setAdding(false)} style={{ padding:"12px 16px", borderRadius:10, border:"1px solid #222", background:"transparent", color:"#555", cursor:"pointer" }}>×</button>
                </div>
              </div>
            ) : (
              <button onClick={() => setAdding(true)} style={{ width:"100%", padding:"14px", borderRadius:12, border:"1.5px dashed #1E1E1E", background:"transparent", color:"#444", fontSize:14, fontWeight:600, cursor:"pointer" }}
                onPointerEnter={e=>{e.currentTarget.style.borderColor="#00E5FF";e.currentTarget.style.color="#00E5FF"}}
                onPointerLeave={e=>{e.currentTarget.style.borderColor="#1E1E1E";e.currentTarget.style.color="#444"}}
              >+ Mitarbeiter hinzufuegen</button>
            )}
          </div>
        )}

        {/* Zeiten Tab */}
        {!loadingReport && activeTab==="attendance" && (
          <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
            {filteredAtt.length===0 && <div style={{ color:"#333", textAlign:"center", padding:"48px 0", fontSize:14 }}>Keine Anwesenheit</div>}
            {[...filteredAtt].reverse().map((a,i) => (
              <div key={i} style={{ background:"#111", border:"1px solid #1A1A1A", borderRadius:14, padding:"12px 14px" }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:6 }}>
                  <div>
                    <div style={{ fontWeight:700, fontSize:15 }}>{a.employeeName}</div>
                    <div style={{ color:"#555", fontSize:10, marginTop:2 }}>{a.date}</div>
                  </div>
                  {a.endTime ? <span style={{ fontSize:10, fontWeight:700, color:"#444", background:"#1A1A1A", border:"1px solid #222", padding:"3px 10px", borderRadius:20 }}>Beendet</span> : <span style={{ fontSize:10, fontWeight:700, color:"#22C55E", background:"#22C55E15", border:"1px solid #22C55E30", padding:"3px 10px", borderRadius:20 }}>● Aktiv</span>}
                </div>
                <div style={{ display:"flex", gap:14, fontSize:12, color:"#555", fontFamily:"Space Mono monospace" }}>
                  <span>Von {a.startTime}</span>
                  {a.endTime && <span>Bis {a.endTime}</span>}
                  <span style={{ color:"#F59E0B" }}>{Number(a.hours||0).toFixed(1)}h</span>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Meldungen Tab */}
        {!loadingReport && activeTab==="meldungen" && (
          <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
            {reportMeldungen.length===0 && <div style={{ color:"#333", textAlign:"center", padding:"48px 0", fontSize:14 }}>Keine Meldungen</div>}
            {[...reportMeldungen].reverse().map((m,i) => (
              <div key={i} style={{ background:"#131313", border:"1px solid #EF444430", borderRadius:14, padding:"12px 14px" }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:6 }}>
                  <div style={{ fontWeight:700, fontSize:15, color:"#EF4444" }}>⚠ {m.employeeName}</div>
                  <div style={{ color:"#555", fontSize:10 }}>{m.date}</div>
                </div>
                <div style={{ color:"#888", fontSize:12, marginBottom:6 }}>Bar-Kasse: EUR {Number(m.barTotal||0).toFixed(2)}</div>
                <div style={{ color:"#CCC", fontSize:13, background:"#0D0D0D", padding:"8px 10px", borderRadius:8 }}>{m.note}</div>
              </div>
            ))}
          </div>
        )}

      {!loadingReport && activeTab==="shopping" && (
        <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
          <button onClick={() => {
            const doc = new jsPDF();
            doc.setFillColor(0,229,255); doc.rect(0,0,210,35,"F");
            doc.setTextColor(0,0,0); doc.setFontSize(22); doc.setFont("helvetica","bold");
            doc.text("XBENT", 14, 18);
            doc.setFontSize(11); doc.setFont("helvetica","normal");
            doc.text("Einkaufsliste - " + today, 14, 28);
            let y = 50;
            ["Huelle","Glass","Zubehoer","Spielzeug"].forEach(cat => {
              const items = shoppingList.filter(s => s.category === cat && !s.done);
              if (items.length === 0) return;
              doc.setFillColor(20,20,20); doc.rect(14,y,182,8,"F");
              doc.setTextColor(0,229,255); doc.setFontSize(10); doc.setFont("helvetica","bold");
              doc.text(cat.toUpperCase(), 16, y+6); y += 12;
              items.forEach((item,i) => {
                if (y > 270) { doc.addPage(); y = 20; }
                if (i%2===0) { doc.setFillColor(248,248,248); doc.rect(14,y-4,182,8,"F"); }
                doc.setTextColor(0,0,0); doc.setFont("helvetica","normal"); doc.setFontSize(9);
                doc.text(item.product, 16, y);
                if (item.note) { doc.setTextColor(150,150,150); doc.text(item.note, 80, y); }
                doc.setTextColor(100,100,100); doc.text(item.employee_name + " " + item.date, 155, y);
                y += 8;
              });
              y += 4;
            });
            doc.save("XBENT-Einkaufsliste-" + today + ".pdf");
          }} style={{ padding:"12px", borderRadius:12, border:"1px solid #F59E0B30", background:"#F59E0B10", color:"#F59E0B", fontSize:13, fontWeight:700, cursor:"pointer" }}>
            PDF Herunterladen
          </button>
          {shoppingList.length===0 && <div style={{ color:"#333", textAlign:"center", padding:"48px 0", fontSize:14 }}>Keine Eintraege</div>}
          {["Huelle","Glass","Zubehoer","Spielzeug"].map(cat => {
            const items = shoppingList.filter(s => s.category === cat);
            if (items.length === 0) return null;
            return (
              <div key={cat}>
                <div style={{ color:"#F59E0B", fontSize:10, letterSpacing:3, marginBottom:8, marginTop:8 }}>{cat.toUpperCase()}</div>
                {items.map((item,i) => (
                  <div key={i} style={{ background:"#111", border:`1px solid ${item.done?"#1A1A1A":"#F59E0B20"}`, borderRadius:12, padding:"12px 14px", display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:6, opacity:item.done?0.4:1 }}>
                    <div>
                      <div style={{ fontWeight:600, fontSize:14, textDecoration:item.done?"line-through":"none" }}>{item.product}</div>
                      {item.note && <div style={{ color:"#555", fontSize:11, marginTop:2 }}>{item.note}</div>}
                      <div style={{ color:"#383838", fontSize:10, marginTop:2 }}>{item.employee_name} · {item.date}</div>
                    </div>
                    <div style={{ display:"flex", gap:6 }}>
                      {!item.done && <button onClick={async () => { await markShoppingDone(item.id); setShoppingList(prev => prev.map(s => s.id===item.id?{...s,done:true}:s)); }} style={{ background:"#22C55E15", border:"1px solid #22C55E30", color:"#22C55E", padding:"6px 10px", borderRadius:8, cursor:"pointer", fontSize:11 }}>✓</button>}
                      <button onClick={async () => { await deleteShoppingItem(item.id); setShoppingList(prev => prev.filter(s => s.id!==item.id)); }} style={{ background:"#EF444410", border:"1px solid #EF444430", color:"#EF4444", padding:"6px 10px", borderRadius:8, cursor:"pointer", fontSize:11 }}>×</button>
                    </div>
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      )}

      </div>
    </div>
  );
}
